import Loadable from 'react/components/loadable';

const BulkBookingCancellationRequestedModal = Loadable({
  loader: () => import('../../pages/calendar/bulk_booking_cancellation_requested_modal'),
  type: 'modal',
});

angular
  .module('shared')
  .value('BulkBookingCancellationRequestedModal', BulkBookingCancellationRequestedModal);
